import React, { useEffect, useRef, useState } from 'react';
import Image, { ImageProps } from 'next/image';
import { useIntersectionObserver } from 'usehooks-ts';

interface ILazyImageProps extends ImageProps {
  threshold?: number;
}

const LazyImage: React.FC<ILazyImageProps> = (props) => {
  const { alt, style, threshold = 0.5 } = props;
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {
    threshold,
    freezeOnceVisible: true,
  });
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!!entry?.isIntersecting) {
      setIsVisible(true);
    }
  }, [entry]);

  return isVisible ? (
    <Image
      {...props}
      alt={alt}
      style={{ opacity: isLoaded ? 1 : 0, transition: '0.3s', ...style }}
      onLoadingComplete={() => setIsLoaded(true)}
      fetchPriority="high"
    />
  ) : (
    <div
      ref={ref}
      style={{
        position: 'absolute',
        zIndex: '100000',
        width: '100%',
        height: '10px',
      }}
    ></div>
  );
};

export default LazyImage;
